import {
	ExperiencePerformanceTypes,
	ExperienceTypes,
	UFOExperience,
} from '@atlassian/ufo/ufo-experimental';

/**
 * Measures the time taken to load and render the Proforma form in Help Center request create.
 *
 * Emitted as `jira.fe.page-segment-load.service-management.help-center.portal-request-create.form`.
 * Started when `ProformaRequestCreate` mounts and succeeded on the `FormRenderer` `RENDER_COMPLETE`
 * lifecycle stage.
 */
export const portalRequestCreateFormExperience = new UFOExperience(
	'service-management.help-center.portal-request-create.form',
	{
		type: ExperienceTypes.Load,
		performanceType: ExperiencePerformanceTypes.PageSegmentLoad,
	},
);
